import axiosInstance from "../api/api";

const DashboardService = {
    getReportsKpi: function (dateFrom, dateTo, filterType, page, size) {
        const params = new URLSearchParams();
        if (dateFrom) params.append('dateFrom', dateFrom);
        if (dateTo) params.append('dateTo', dateTo);
        if (filterType) params.append('filterType', filterType);
        if (page !== undefined) params.append('page', page);
        if (size !== undefined) params.append('size', size);
        
        return axiosInstance({
            url: `/api/dashboard/reportsKpi?${params.toString()}`,
            method: "GET",
        });
    }
};

export default DashboardService;

